const SocialIcons = ({ iconColor, iconHover, iconSize }) => {
  return (
    <>
      <a
        href="https://www.linkedin.com/company/talentlift-canada/about/"
        className={`${iconColor} hover:${iconHover}`}
        target="_blank"
      >
        <i className={`fa-brands fa-linkedin ${iconSize}`}></i>
      </a>
      <a href="https://www.youtube.com/@talentlift" className={`${iconColor} hover:${iconHover}`} target="_blank">
        <i className={`fa-brands fa-youtube ${iconSize}`}></i>
      </a>
      <a
        href="https://www.facebook.com/TalentLiftCanada/"
        className={`${iconColor} hover:${iconHover}`}
        target="_blank"
      >
        <i className={`fa-brands fa-facebook ${iconSize}`}></i>
      </a>
      <a
        href="https://www.instagram.com/talentliftcanada"
        className={`${iconColor} hover:${iconHover}`}
        target="_blank"
      >
        <i className={`fa-brands fa-square-instagram ${iconSize}`}></i>
      </a>
    </>
  )
}

export default SocialIcons
